import React, { Fragment, useState } from 'react';
import './Home.scss';
import Boost from '../..//components/Boost/index';

// IMAGES
import working from '../../images/illustration-working.svg';
import brandRecognition from '../../images/icon-brand-recognition.svg';
import detailedRecords from '../../images/icon-detailed-records.svg';
import customizable from '../../images/icon-fully-customizable.svg';

export default function Home() {
  const [linkShortened, setLinkShortened] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [message, setMessage] = useState('');

  const inputField = document.getElementById('shorten-input');

  function inputHandle(e) {
    setInputValue(e.target.value);
    setLinkShortened(false);
  }

  function shortenClickHandle() {
    if (inputValue === '') {
      noTextError();
    } else if (linkShortened === false) {
      // setLinkShortened(true);
      processUrl();
    }
  }

  function shortenKeyHandle(e) {
    if (inputValue === '') {
      noTextError();
    } else if (e.keyCode === 13 && linkShortened === false) {
      // setLinkShortened(true);
      processUrl();
    }
  }

  function noTextError() {
    setMessage('Please enter a URL first!');
    setTimeout(() => {
      setMessage('');
    }, 2500);
  }

  function processUrl() {
    if (inputValue.startsWith('https://') || inputValue.startsWith('http://')) {
      shorten(inputValue);
    } else {
      shorten(`https://${inputValue}`);
    }
  }

  async function shorten(shortenUrl) {
    const apiUrl = 'https://rel.ink/api/links/';
    const request = { url: shortenUrl };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      const hashId = data.hashid;
      if (data.hashid === undefined) {
        setMessage('Sorry, this URL is invalid!');
        setLinkShortened(false);
        setTimeout(() => {
          setMessage('');
        }, 2500);
      } else if (data.hashid !== undefined) {
        setInputValue(`https://rel.ink/${hashId}`);
        setLinkShortened(true);
      }
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  }

  // copy shortened url to user's clipboard
  function copyToClipBoardHandle() {
    inputField.select();
    inputField.setSelectionRange(0, 9999); // For mobile

    document.execCommand('copy');
    setMessage(`URL copied to clipboard: ${inputValue}`);
    setTimeout(() => {
      setMessage('');
    }, 2500);
  }
  return (
    <Fragment>
      <header className='home-header'>
        <img
          className='home-header__img'
          src={working}
          alt='woman sitting at desk'
        />
        <div className='home-header__text'>
          <h1 className='home-header__h1'>More than just shorter links</h1>
          <h2 className='home-header__h2'>
            Build your brand’s recognition and get detailed insights on how your
            links are performing.
          </h2>

          <a href='#shorten-input'>
            <button className='btn long-btn'>Get Started</button>
          </a>
        </div>
      </header>

      <main className='shorten'>
        <div className='shorten__input-and-button'>
          <input
            className='shorten__input'
            id='shorten-input'
            type='text'
            placeholder='Shorten a link here...'
            onChange={inputHandle}
            onKeyDown={shortenKeyHandle}
            value={inputValue}
          />
          {linkShortened ? (
            <button
              className='btn shorten__copy-btn'
              id='copy-btn'
              onClick={copyToClipBoardHandle}
            >
              Copy URL
            </button>
          ) : (
            <button
              className='btn shorten__btn'
              id='shorten-btn'
              onClick={shortenClickHandle}
            >
              Shorten It!
            </button>
          )}
        </div>
        <p className='shorten__message-field' id='message-field'>
          {message}
        </p>
      </main>

      <section className='stats'>
        <div className='stats__heading-container'>
          <h3>Advanced Statistics</h3>
          <p className='stats__heading-text'>
            Track how your links are performing across the web with our advanced
            statistics dashboard.
          </p>
        </div>
        <div className='stats__containers'>
          <div className='stats__container first-container'>
            <div className='circle-img'>
              <img src={brandRecognition} alt='icon of flowchart' />
            </div>
            <h4>Brand Recognition</h4>
            <p>
              Boost your brand recognition with each click. Generic links don’t
              mean a thing. Branded links help instill confidence in your
              content.
            </p>
          </div>
          <div className='container__line'></div>
          <div className='wrapper'>
            <div className='stats__container second-container'>
              <div className='circle-img'>
                <img src={detailedRecords} alt='icon of gauge' />
              </div>
              <h4>Detailed Records</h4>
              <p>
                Gain insights into who is clicking your links. Knowing when and
                where people engage with your content helps inform better
                decisions.
              </p>
            </div>
          </div>
          <div className='container__line'></div>
          <div className='stats__container third-container'>
            <div className='circle-img'>
              <img src={customizable} alt='icon of marker, pen, and brush' />
            </div>
            <h4>Fully Customizable</h4>
            <p>
              Improve brand awareness and content discoverability through
              customizable links, supercharging audience engagement.
            </p>
          </div>
        </div>
      </section>

      <Boost />
    </Fragment>
  );
}
